import { render, staticRenderFns } from "./PriorityBadge.vue?vue&type=template&id=495dce8b&scoped=true"
import script from "./PriorityBadge.vue?vue&type=script&lang=ts"
export * from "./PriorityBadge.vue?vue&type=script&lang=ts"
import style0 from "./PriorityBadge.vue?vue&type=style&index=0&id=495dce8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495dce8b",
  null
  
)

export default component.exports